import React, { useState } from 'react';
import { AgentTaskEvent } from '../../types/admin';
import styles from './TimelineEvent.module.css';

interface TimelineEventProps {
  event: AgentTaskEvent;
}

export const TimelineEvent: React.FC<TimelineEventProps> = ({ event }) => {
  const [expanded, setExpanded] = useState(false);

  const formatTimestamp = (timestamp: string): string => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString('en-US', { hour12: false, fractionalSecondDigits: 3 });
  };

  const getEventTypeLabel = (eventType: string): string => {
    const labels: Record<string, string> = {
      task_started: '🚀 Task Started',
      llm_request: '💭 LLM Request',
      llm_response: '✨ LLM Response',
      tool_call_start: '🔧 Tool Call Start',
      tool_call_end: '✅ Tool Call End',
      tool_call_error: '❌ Tool Error',
      iteration_complete: '🔄 Iteration Complete',
      task_complete: '🎉 Task Complete',
      task_error: '💥 Task Error',
    };
    return labels[eventType] || eventType;
  };

  const getEventClass = (eventType: string): string => {
    if (eventType.includes('error')) return styles.eventError;
    if (eventType.includes('complete')) return styles.eventSuccess;
    if (eventType.includes('llm')) return styles.eventLlm;
    if (eventType.includes('tool')) return styles.eventTool;
    return styles.eventDefault;
  };

  return (
    <div className={`${styles.event} ${getEventClass(event.eventType)}`}>
      <div className={styles.eventHeader} onClick={() => setExpanded(!expanded)}>
        <span className={styles.eventType}>{getEventTypeLabel(event.eventType)}</span>
        <span className={styles.eventMeta}>
          <span className={styles.timestamp}>{formatTimestamp(event.timestamp)}</span>
          {event.durationMs !== null && event.durationMs !== undefined && (
            <span className={styles.duration}>{event.durationMs}ms</span>
          )}
          <span className={styles.expandIcon}>{expanded ? '▼' : '▶'}</span>
        </span>
      </div>
      {expanded && (
        <div className={styles.eventData}>
          <pre className={styles.jsonData}>{JSON.stringify(event.data, null, 2)}</pre>
        </div>
      )}
    </div>
  );
};
